import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
// import { GlobalPage } from '../global/global';

/**
 * Generated class for the PinpopoverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pinpopover',
  templateUrl: 'pinpopover.html',
})
export class PinpopoverPage {
  wo: any
  cb: any
  from: any
  alert: any
  _multipleorders = '0'

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public alertCtrl: AlertController, public toastCtrl: ToastController, public viewCtrl: ViewController) {
    this.wo = navParams.get('wo')
    this.cb = navParams.get('cb');
    this.from = navParams.get('where');
    this._multipleorders = navParams.get('multipleorders')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PinpopoverPage');
  }



  takeOrderPin() {
    var _status = 0
    var titletext = ''
    var subtitletext = ''
    if (this.wo.isopened == '0') {
      _status = 1;
      titletext = this.dic.l['Takeorder'];
      subtitletext = this.dic.l['areusuretakeorder'];
    } else {
      _status = 0;
      titletext = this.dic.l['Closeorder'];
      subtitletext = this.dic.l['areusurecloseorder'];
    }

    var _that = this;
    let alert = _that.alertCtrl.create({
      title: titletext,
      subTitle: subtitletext + ' <b>' + this.wo.title + '</b> ?',
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            _that.gn.loadWaiting();
            _that.gn._Post('/api/gn/updateStatusPinWorkOrder', { driverid: _that.gn.crypt(_that.gn.user.driverid), pinid: _that.gn.crypt(_that.gn.pin.pinid), id: _that.gn.crypt(this.wo.id), status: _that.gn.crypt(_status), clientid: _that.gn.crypt(_that.gn.user.ClientId), userid: _that.gn.crypt(_that.gn.user.UserId) }, function (_data) {
              _that.gn.loaderWaiting.dismiss();
              if (_data.msg == 'error') {
                let toast = _that.toastCtrl.create({ message: _that.dic.l["someonetookit"], duration: 3000, position: 'top' });
                toast.present();
                return
              }


              _that.navCtrl.pop();
              _that.cb(0);

            })
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel',
          handler: data => {
            _that.viewCtrl.dismiss();
          }
        }
      ]
    });
    alert.present();
  }




  takeOrderBeacon() {
    var _status = 0
    var titletext = ''
    var subtitletext = ''
    if (this.wo.incoming + '' == '0' || this.wo.assignrfid + '' == '0') {
    } else {
      var _status = 0
      if (this.wo.isopened + '' == '0') {
        _status = 1
        titletext = this.dic.l['Takeorder'];
        subtitletext = this.dic.l['areusuretakeorder'];
      } else {
        _status = 0
        titletext = this.dic.l['Closeorder'];
        subtitletext = this.dic.l['areusurecloseorder'];
      }

      var _that = this;
      let alert = _that.alertCtrl.create({
        title: titletext,
        subTitle: subtitletext + ' <b>' + this.wo.title + '</b> ?',
        buttons: [
          {
            text: _that.dic.l['ok'],
            handler: data => {
              _that.gn._Post('/api/gn/updateStatusPinWorkOrder', { driverid: _that.gn.crypt(_that.gn.user.driverid), pinid: _that.gn.crypt(_that.gn.pin.pinid), id: _that.gn.crypt(this.wo.id), status: _that.gn.crypt(_status), clientid: _that.gn.crypt(_that.gn.user.ClientId), userid: _that.gn.crypt(_that.gn.user.UserId) }, function (_data) {
                if (_data.msg == 'error') {
                  let toast = _that.toastCtrl.create({ message: _that.dic.l["someonetookit"], duration: 3000, position: 'top' });
                  toast.present();
                  return
                }
                _that.navCtrl.pop();
                _that.cb(0);

              })
            }
          },
          {
            text: _that.dic.l['cancel'],
            role: 'cancel'
          }
        ]
      });
      alert.present();
    }
  }

  closed() {
    if (this.from == 1) {
      this.takeOrderPin()
    } else {
      this.takeOrderBeacon()
    }

  }

  back() {
    // if (this.from == 1) {
    this.backorderpin()
    // } else {

    // }
  }

  pause(_tf) {
    var _hasopenedorder = false;
    if (_tf + '' == '0') {
      for (var i = 0; i < this.gn.workoders.length; i++) {
        if (this.gn.workoders[i].isopened == '1' && this.gn.workoders[i].onpause1 == 0 && this.gn.workoders[i].id != this.wo.id)
          _hasopenedorder = true;
      }
      if (_hasopenedorder && this._multipleorders == '0') {
        let toast = this.toastCtrl.create({ message: this.dic.l["cannottakeorder1"], duration: 3000, position: 'top' });
        toast.present();
        return
      } else {
        this.pauseorderpin(_tf)
      }
    } else {
      this.pauseorderpin(_tf)
    }

  }

  backorderpin() {
    var titletext = 'Врати налог'
    var subtitletext = 'Дали сте сигурни дека сакате да го вратите налогот'


    var _that = this;
    let alert = _that.alertCtrl.create({
      title: titletext,
      subTitle: subtitletext + ' <b>' + this.wo.title + '</b> ?',
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            _that.gn.loadWaiting();
            _that.gn._Post('/api/gn/backPin', { id: _that.gn.crypt(this.wo.id) }, function (_data) {
              _that.gn.loaderWaiting.dismiss();

              _that.navCtrl.pop();
              _that.cb(0);

            })
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel',
          handler: data => {
            _that.viewCtrl.dismiss();
          }
        }
      ]
    });
    alert.present();
  }

  pauseorderpin(_tf) {
    var titletext = 'Пауза на налог'
    var subtitletext = 'Дали сте сигурни дека сакате да започнете пауза на налогот'
    if (_tf == 0)
      subtitletext = 'Дали сте сигурни дека сакате да ја завршите паузата на налогот'

    var _that = this;
    let alert = _that.alertCtrl.create({
      title: titletext,
      subTitle: subtitletext + ' <b>' + this.wo.title + '</b> ?',
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            _that.gn.loadWaiting();
            _that.gn._Post('/api/gn/pausePin', { id: _that.gn.crypt(_that.wo.id), tf: _that.gn.crypt(_tf), ptype: _that.gn.crypt(_that.wo.ptype), driverid: _that.gn.crypt(_that.wo.currentdriverid), pinid: _that.gn.crypt(_that.wo.currentpinid) }, function (_data) {
              _that.gn.loaderWaiting.dismiss();

              _that.navCtrl.pop();
              _that.cb(1);

            })
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel',
          handler: data => {
            _that.viewCtrl.dismiss();
          }
        }
      ]
    });
    alert.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/pinpopover/pinpopover.ts